export enum BaseContractSigningTypeEnum {
  DIGITAL = 'digital',
  EXTERNAL = 'external',
  CONCRETISATION = 'concretisation',
}
